import { gql } from 'graphql-request'

export const RESET_PIN_CODE = gql`
  mutation ResetUserMobilePin($userId: Float!) {
    resetUserMobilePin(userId: $userId) {
      message
    }
  }
`
